export default __webpack_public_path__ + "static/marketing-presentation_by-916633eae4c2cfb77241b808fac60822.png";